<template>
  <div class="selectCard">
    <div class="checkBoxWild">
      <el-radio v-model="itemData.checkedStatus" :label="itemData.user.userId" @input="changeCheck"></el-radio>
    </div>
    <div class="imgBox">
      <el-image style="width: 32px; height: 32px" :src="itemData.user && itemData.user.avatar" fit="fill">
        <img src="../../common/images/head.png" slot="error" />
      </el-image>
    </div>
    <p v-show="!itemData.user.ifOwn" class="imgBox-without">外</p>
    <div class="textBox">
      <div class="titleText">
        <!-- <span v-if="itemData.user.username.length > 10">{{}}</span> -->
        <!-- v-if="itemData.user.username.length > 6" -->
        <!-- :content="`【${'部门'}】${itemData.user.username}`" -->
        <el-tooltip class="item" :content="formatUsername(itemData.user)" effect="dark" placement="top"
          :open-delay="500">
          <div class="user-box-content">{{ title }}（{{ itemData.user.username }}）</div>
        </el-tooltip>
        <!-- <span v-else>（{{ itemData.user.username }}）</span> -->
      </div>
      <div v-if="!itemData.user.ifOwn" class="orgText">{{ itemData.userJob && itemData.userJob.phone }}</div>
      <div v-else class="orgText">{{ itemData.userJob && computedStr(itemData.userJob.orgPathName) }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'selectRadioCard',
  props: {
    title: String,
    itemData: {
      type: Object,
      default: () => {}
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  created() {},
  data() {
    return {};
  },
  methods: {
    computedStr(val) {
      if (val) {
        let arr = val.split('>');
        return arr[arr.length - 1];
      } else {
        return '';
      }
    },
    changeCheck(val) {
      this.$emit('radioSelect', this.itemData);
    }
  },
  computed:{
    formatUsername(){
      return (user)=>{
        return user.idmOrgName?`【${user.idmOrgName}】${user.username}`:`${user.username}`
      }
    }
  },
  watch: {
    selectedList: {
      handler(newVal, oldVal) {
        let find = false;
        this.selectedList.map(item => {
          if (item.user.userId == this.itemData.user.userId) {
            find = true;
          }
        });

        if (find) {
          this.itemData.checkedStatus = this.itemData.user.userId;
        } else {
          this.itemData.checkedStatus = '';
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.selectCard {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;

  ::v-deep .el-radio__label{
    display: none;
  }

  .checkBoxWild {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    /*    margin-right: 5px;*/
    width: 20px;
  }

  .imgBox {
    // position: relative;
    width: 32px;
    margin-right: 3px;
    border-radius: 50%;
    overflow: hidden;
  }

  .imgBox-without {
    position: absolute;
    bottom: 0;
    left: 38px;
    width: 16px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 50%;
    background: #fc563e;
    font-size: 12px;
    text-align: center;
  }

  .textBox {
    width: calc(100% - 65px);

    .titleText {
      font-size: 14px;
      line-height: 18px;
      font-weight: bolder;
    }

    .orgText {
      font-size: 12px;
      cursor: pointer;
      line-height: 16px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
    }
  }
}
.user-box-content{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
}
.itemTooltip {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
